import { NextResponse, type NextRequest } from 'next/server'
import type { Language } from 'ecosystem'
import { setRequestLocale } from '../../../common/api/setRequestLocale'
import { routeHandlerWithLogging } from '../../../logging/routeHandlerWithLogging'
import { type InvoiceOrderHandlerOpts } from './types'

/**
 * The preamble all three invoice endpoints share: refuse an anonymous caller,
 * install the market's api credentials, and turn any throw into a 400.
 *
 * The pages versions repeated this block verbatim in each handler, along with a
 * `req.method !== 'POST'` check that an App Router `POST` export makes
 * unreachable.
 */
export const withInvoiceGuards = (
  opts: InvoiceOrderHandlerOpts,
  handle: (request: NextRequest, locale: Language) => Promise<NextResponse>
) =>
  routeHandlerWithLogging(async function POST(request: NextRequest) {
    if (!opts.customerId) {
      return NextResponse.json(
        { error: 'Unauthorized — invoice flow requires a signed-in customer.' },
        { status: 401 }
      )
    }

    const credentialsLocale = setRequestLocale(request)

    try {
      return await handle(request, opts.locale || credentialsLocale)
    } catch (e) {
      return NextResponse.json(
        { error: e instanceof Error ? e.message : 'Unknown error' },
        { status: 400 }
      )
    }
  })
